import { render, staticRenderFns } from "./FeedbackIlustra.vue?vue&type=template&id=4b6e09e6&scoped=true&"
import script from "./FeedbackIlustra.vue?vue&type=script&lang=ts&"
export * from "./FeedbackIlustra.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackIlustra.vue?vue&type=style&index=0&id=4b6e09e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6e09e6",
  null
  
)

export default component.exports